import { useEffect, useState, useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'

// import { useSearchParams } from 'utils/search-params-router'
import { useErrors } from 'common-components/errors'

import * as requests from './requests'
import request, { ResponseError } from './request'
import host from './api-host';


  export default function useFetch<T>(
  rq: requests.Request<T>,
  params?: {}, // TODO <K>
  autoload: boolean = true
): [T, boolean, { request: () => Promise<void> }] {
  const { t } = useTranslation()
  const [, errorsActions] = useErrors()

  const searchParams = new URLSearchParams(window.location.search)
  const auth = searchParams.get('auth') || undefined

  const [state, setState] = useState<T>(rq.defaultState)
  const [loading, setLoading] = useState<boolean>(true)


  const { url, method, error } = rq
  const data = method === 'GET' ? undefined : params


  const requestUrl = useMemo(() => {
    const someUrl = new URL(url, host)
    if (method === 'GET' && params) {
      someUrl.search = new URLSearchParams(params).toString()
    }
    return someUrl.toString()
  }, [method, params, url])


  const handleError = useCallback((err: ResponseError, requestParams?: any) => {
    errorsActions.throwError(t(error(err)), err.response, requestParams)
  }, [t, error, errorsActions])


  const handleRequest = useCallback(async () => {
  try {
    setLoading(true)
    setState(rq.defaultState)
    const res = await request<T>(
      requestUrl,
      method,
      data,
      auth,
      handleError
    )
    setLoading(false)
    if (res) {
      setState(res)
    }
  } catch(error) {
    // console.log(error, error.name)
    if (error?.name === 'AbortError' || error?.name === 'TypeError') {
      errorsActions.throwTimeoutError()
    }
  }
}, [handleError, method, requestUrl, data, auth, rq.defaultState, errorsActions]);


  useEffect(() => {
    if (!auth) {
      errorsActions.throwError(t(
        'template_cafeteria_menu.api_errors.auth',
        'Неверная ссылка (отсутствует авторизация)'
      ))
      return
    }
    if (autoload) {
      (async () => {
        handleRequest()
      })()
    }
  }, [autoload, params, auth]) // eslint-disable-line react-hooks/exhaustive-deps


  const handlers: { request: () => Promise<void> } = useMemo(() => (
    { request: handleRequest }
  ), [handleRequest])

  return [state, loading, handlers]
}
